import React, {useEffect,useState} from "react";
import {Link,useParams, Router} from 'react-router-dom';
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import Header from '../../component/Header';
import Filter from '../../component/Filter';
import Sidebar from '../../component/Sidebar';
import { API_URL } from "../../../config";

const Viewdatareport = () =>{
    const { t } = useTranslation();
    const accessToken = localStorage.getItem('accessToken');
    const [sreports, setviewsreports] = useState([]);
    const [mreports, setviewmreports] = useState([]);
    const sessionid = localStorage.getItem('selectedSession');
    const Clientid = localStorage.getItem('selectedClient');
    const [selectedClient,setSelectedClient] = useState() ;
    const [selectedSession,setSelectedSession] = useState();
    const [selectedGroup,setselectedGroup] = useState() ;
    const [selectedHomework,setselectedHomework] = useState();
    const [userType,setUserType] = useState() ;
    const [selectedstandard, setSelectedstandard] = useState();
    const [selectedclientactive, setSelectedclientactive] = useState();
    const [selectedtraineractive, setSelectedtraineractive] = useState()

    

    useEffect(() => {


        setInterval(() => {
            setSelectedClient(localStorage.getItem('selectedClient'));
            setSelectedSession(localStorage.getItem('selectedSession'));
            setselectedGroup(localStorage.getItem('selectedGroup'));
            setselectedHomework(localStorage.getItem('selectedHomework'));
            setSelectedstandard(localStorage.getItem('selectedStandard'));
            setSelectedclientactive(localStorage.getItem('selectedclientActive'));
            setSelectedtraineractive(localStorage.getItem('selectedtrainerActive'));
           setUserType(localStorage.getItem('userType'));
        }, 100);

    }, []); 

    useEffect(() => {
        Singlesession();
        Multisession();
    },[selectedSession,selectedClient,selectedGroup,selectedHomework])
      
    const Singlesession = () => {
        fetch(API_URL+"/report/single?session_id=" + sessionid,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.warn("result", resp);
                    setviewsreports(resp.reports);
                 
                   

                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }


        })
    }
    const Multisession = () => {
        fetch(API_URL+"/report/multiple?client_id=" + Clientid,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.warn("result", resp);
                    setviewmreports(resp.reports);
                   

                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }


        })
    }
    const logout = () => {
        localStorage.clear();
        // alert("You Logout successful")
    }


    return(
        <div>
        <Header />
        <div className="wrp-dashbord">
            <div className="sidebar-section">
             <Sidebar />
            </div>
            <div className="right-section">
            <Filter managesessionid="2" />
            <div className="create-section">
                       <ul className="create-list">

                        {
                            userType == 3?<> <li>
                            <div className="create-list-box"><Link to={(sreports.length == 0 || selectedSession === "" || selectedSession === "null" || selectedGroup === "true" || selectedHomework === "true" || selectedClient === "" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/single" } className={(sreports.length == 0 || (selectedSession === ""  || selectedSession === "null" ||  selectedGroup === "true" || selectedHomework === "true" || selectedClient === "") || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "deactivate": "" }>{t('Session-Data-Reports')}</Link></div>
                        </li>
                        {/* <li>
                        
                            <div className="create-list-box"><Link to={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null")) ? "": "/session/data/report/multi" } className={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null")) ? "deactivate": "" }>{t('Multi-session-Data-Reports')}</Link></div>
                        </li> */}
                       
                            <li>
                                <div className="create-list-box"><Link to={( sreports.length == 0 || selectedSession === "" || selectedSession === "null" || selectedHomework === "false" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/homework" } className={(sreports.length == 0 || selectedSession === "" ||selectedSession === "null" || selectedHomework === "false" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "deactivate": "" }>{t('Client-Homework-Data-Reports')}</Link></div>
                            </li></>:userType == 2?<> <li>
                            <div className="create-list-box"><Link to={(sreports.length == 0 || selectedSession === "" || selectedSession === "null" || selectedGroup === "true" || selectedHomework === "true" || selectedClient === "" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/single" } className={(sreports.length == 0 || (selectedSession === ""  || selectedSession === "null" ||  selectedGroup === "true" || selectedHomework === "true" || selectedClient === "") || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "deactivate": "" }>{t('Session-Data-Reports')}</Link></div>
                        </li>
                        <li>
                        
                            <div className="create-list-box"><Link to={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null") || selectedclientactive == "false" || selectedtraineractive == "false") ? "": "/session/data/report/multi" } className={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null") || selectedclientactive == "false" || selectedtraineractive == "false") ? "deactivate": "" }>{t('Multi-session-Data-Reports')}</Link></div>
                        </li>
                       
                            <li>
                                <div className="create-list-box"><Link to={( sreports.length == 0 || selectedSession === "" || selectedSession === "null" || selectedHomework === "false" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/homework" } className={(sreports.length == 0 || selectedSession === "" ||selectedSession === "null" || selectedHomework === "false" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "deactivate": "" }>{t('Client-Homework-Data-Reports')}</Link></div>
                            </li></>:<> <li>
                            <div className="create-list-box"><Link to={(sreports.length == 0 || selectedSession === "" || selectedSession === "null" || selectedGroup === "true" || selectedHomework === "true" || selectedClient === "" || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/single" } className={(sreports.length == 0 || (selectedSession === ""  || selectedSession === "null" ||  selectedGroup === "true" || selectedHomework === "true" || selectedClient === "") || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "deactivate": "" }>{t('Session-Data-Reports')}</Link></div>
                        </li>
                        <li>
                        
                            <div className="create-list-box"><Link to={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null") || selectedclientactive == "false" || selectedtraineractive == "false" || selectedstandard == "false") ? "": "/session/data/report/multi" } className={(mreports.length == 0 || selectedClient === "" || selectedGroup === "true" || (selectedSession !== "" && selectedSession !== "null") || selectedclientactive == "false" || selectedtraineractive == "false") ? "deactivate": "" }>{t('Multi-session-Data-Reports')}</Link></div>
                        </li>
                        <li>
                                <div className="create-list-box"><Link to={(sreports.length == 0 || selectedSession === "" || selectedGroup === "false" || selectedSession === "" || selectedSession === "null" || selectedstandard == "false" || selectedclientactive == "false" || selectedtraineractive == "false") ? "": "/session/data/report/group" } className={(sreports.length == 0 || selectedSession === "" || selectedGroup === "false" || selectedSession === "" ||selectedSession === "null" || selectedstandard == "false" || selectedclientactive == "false" || selectedtraineractive == "false") ? "deactivate": "" }>{t('Group-Session-Data-Reports')}</Link></div>
                            </li>
                            <li>
                                <div className="create-list-box"><Link to={( selectedSession === "" || selectedSession === "null" || selectedHomework === "false" || sreports.length == 0 || selectedGroup == "true" || selectedclientactive == "false" || selectedtraineractive == "false") ? "": "/session/data/report/homework" } className={(selectedSession === "" ||selectedSession === "null" || selectedHomework === "false" || sreports.length == 0 || selectedGroup == "true" || selectedclientactive == "false" || selectedtraineractive == "false")? "deactivate": "" }>{t('Client-Homework-Data-Reports')}</Link></div>
                            </li></>
                        }
                       
                       
                       </ul>
                   </div>
              
            </div>
        </div>
     </div>

    )
}

export default Viewdatareport;